<template>
    <div>
        <div class="-companies">
            <div>
                <loader v-show="loading" class="bigger-loader"></loader>
                <button class="btn btn-primary btn-sm"
                        @click.prevent="addContractType"
                        :disabled="!company.id">
                    <i class="glyphicon glyphicon-plus"></i>
                    Ajouter un type de contrat
                </button>
                <div class="btn-group btn-wrapper-save"
                     v-show="diff.length > 0">
                    <button class="btn btn-success btn-sm"
                            @click="save(company)"
                            :disabled="!valid">
                        <i class="glyphicon glyphicon-ok"></i>
                    </button>
                    <button class="btn btn-danger btn-sm"
                            @click="cancel">
                        <i class="glyphicon glyphicon-remove"></i>
                    </button>
                </div>
                <table v-if="!loading"
                       class="table table-hover -contract-types -row-links">
                    <tr>
                        <th>Type</th>
                        <th style="width: 30%">Automatisation</th>
                    </tr>
                    <tr v-for="type in types" class="row-contract-type">
                        <td class="table-col">
                            <editable-text
                                :value.sync="type.name"
                                placeholder="Aucun"
                            ></editable-text>
                        </td>
                        <td class="table-col">
                            <editable-choice
                                :options="automationTypes"
                                :value.sync="type.automation_type"
                            ></editable-choice>
                        </td>
                    </tr>
                </table>
                <loader v-show="loading" class="bigger-loader"></loader>

                <div class="load-more">
                    <a href="#"
                       v-if="hasNext && !loading"
                       v-on:click.prevent="updateList(true)"
                       class="btn btn-default">
                        Charger plus
                    </a>
                </div>
            </div>

        </div>
    </div>
</template>

<style lang="less" type="text/less" scoped>
    .btn-wrapper-save {
        float: right;
    }
    .-contract-types {
        margin-top: 20px;
    }
</style>

<script>
    import EditableText from '../editable/EditableText';
    import EditableChoice from '../editable/EditableChoice';
    import Loader from '../Loader';
    import {
        automationTypes,
        emptyType,
        isAutomationTypeValid
    } from '../../api/companies';

    export default {
        components: {
            EditableText,
            EditableChoice,
            Loader
        },
        data() {
            return {
                hasNext: false,
                types: [],
                oldTypes: [],
                diff: []
            };
        },
        props: {
            company: {}
        },
        watch: {
            'types': {
                deep: true,
                handler() {
                    this.diff = this.processDiff();
                }
            }
        },
        computed: {
            /**
             * Return true if all fields are valid, if so, the user can save
             * the form
             * @returns {boolean}
             */
            valid() {
                return this.types.every(type =>
                    type.name.length > 0 &&
                    isAutomationTypeValid(type.automation_type)
                );
            },

            automationTypes
        },
        methods: {
            /**
             * Append an empty line contracttype
             */
            addContractType() {
                this.types.push(emptyType());
            },

            /**
             * Save ContractTypes and attach them to the company
             * Actually, it will make a call to the company api
             */
            save(company) {
                this.$parent.save(company);
            },

            /**
             * Called when the user don't want to save the data, and rollback
             * its changes
             **/
            cancel() {
                this.types =
                    this.oldTypes.map(obj => Object.assign({}, obj)).slice(0);
                this.diff = [];
            },

            /**
             * create an array of index containing all indexes of producttype
             * that need to be updated
             * @returns {*|Array}
             */
            processDiff() {
                return this.types.reduce((acc, curr, i) => {
                    const values = Object.values(curr);
                    if (!this.oldTypes[i]) {
                        acc.push(i);
                        return acc;
                    }
                    const isSame = Object.values(this.oldTypes[i]).every(
                        (val, i) => val === values[i]);
                    if (!isSame) {
                        acc.push(i);
                    }
                    return acc;
                }, []);
            }
        },
        ready() {
            this.types = this.company.types;
            this.oldTypes =
                this.types.map(obj => Object.assign({}, obj)).slice(0);
        },
        name: 'contract-types'
    };
</script>



// WEBPACK FOOTER //
// ContractTypes.vue?d51b929e